<div class="logo">
    <img src="/assets/WorkBuddy.svg">
</div>

<div class="header">Access Denied</div>

<div class="content">

    <div class="alert alert-info">
        Your login was successful but your account is not associated with any WorkBuddy tenants. <br> <br> To continue, you must be invited by a tenant administrator or you must use a different login.
    </div>

</div>